import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import { useGroupManager } from "../../hooks/useGroupManager";

export function MobileArrows() {
  const { selectedGroup, handleAdd, handleRemove } = useGroupManager();

  return (
    <div className="flex flex-col gap-3">
      <button
        className={`border border-black px-4 py-1 ${
          selectedGroup
            ? "bg-secondary-yellow hover:bg-tertiary-yellow text-white"
            : "bg-gray-400"
        }`}
        onClick={handleRemove}
      >
        <FaArrowUp className="inline" /> {" Retirer du groupe"}
      </button>
      <button
        className={`border border-black  px-4 py-1 ${
          selectedGroup
            ? "bg-secondary-blue hover:bg-tertiary-blue text-white"
            : "bg-gray-400"
        }`}
        onClick={handleAdd}
      >
        {"Ajouter au groupe "}
        <FaArrowDown className="inline" />
      </button>
    </div>
  );
}
